import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, Swords, Shield, Users, Crown, Flame, ChevronRight, Zap, CheckCircle2 } from "lucide-react";

export default function EsportsTournamentBracket() {
  const [activeTab, setActiveTab] = useState("cs16_cup");

  const tournaments = {
    cs16_cup: {
      title: "INDUNGI x PLAYZEK CS 1.6 MASTERS // S1",
      prize: "5.000 IDG COINS + 3x VIP DIAMOND",
      game: "CS 1.6 5v5",
      status: "LIVE // SEMI-FINALS",
      quarterFinals: [
        { t1: "DARK LEGION", s1: 16, t2: "CYBER WOLVES", s2: 12, winner: 1 },
        { t1: "KINGS OF DUST", s1: 14, t2: "INDUNGI ELITE", s2: 16, winner: 2 },
        { t1: "NEON STRIKERS", s1: 16, t2: "PRO AIMERS", s2: 8, winner: 1 },
        { t1: "VALOR TEAM", s1: 16, t2: "ZERO RECOIL", s2: 11, winner: 1 },
      ],
      semiFinals: [
        { t1: "DARK LEGION", s1: 16, t2: "INDUNGI ELITE", s2: 13, winner: 1, live: false },
        { t1: "NEON STRIKERS", s1: 11, t2: "VALOR TEAM", s2: 14, winner: 2, live: true },
      ],
      grandFinal: {
        t1: "DARK LEGION",
        t2: "TBD (NEON vs VALOR)",
        date: "Duminică, 21:00",
        map: "de_dust2 & de_inferno"
      }
    },
    cs2_cup: {
      title: "PLAYZEK CS2 PREMIER 5v5 // WINTER OPEN",
      prize: "10.000 IDG COINS + TROFEU SPECIAL",
      game: "Counter-Strike 2",
      status: "ÎNSCRIERI DESCHISE",
      quarterFinals: [
        { t1: "TEAM RAZOR", s1: "-", t2: "VIP SQUAD", s2: "-", winner: 0 },
        { t1: "PHANTOM 5", s1: "-", t2: "RED DRAGONS", s2: "-", winner: 0 },
        { t1: "CLAN BLING", s1: "-", t2: "RO GAMING", s2: "-", winner: 0 },
        { t1: "NIGHT OPS", s1: "-", t2: "ALPHA DOGS", s2: "-", winner: 0 },
      ],
      semiFinals: [
        { t1: "TBD", s1: "-", t2: "TBD", s2: "-", winner: 0 },
        { t1: "TBD", s1: "-", t2: "TBD", s2: "-", winner: 0 },
      ],
      grandFinal: {
        t1: "TBD",
        t2: "TBD",
        date: "Sâmbătă viitoare, 20:00",
        map: "de_mirage / de_nuke"
      }
    }
  };

  const tourney = tournaments[activeTab];

  return (
    <div className="bg-[#080c14] border border-[#161f30] rounded-xl p-5 shadow-2xl relative overflow-hidden group">
      {/* Glow highlight */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[radial-gradient(ellipse_at_top_right,rgba(0,255,136,0.08),transparent_70%)] pointer-events-none" />

      {/* Header with Title and Tabs */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-b border-[#141b2a] pb-4 mb-6">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <span className="px-2.5 py-0.5 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 text-[10px] font-mono font-black uppercase tracking-widest flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse" />
              {tourney.status}
            </span>
            <span className="text-zinc-400 text-xs font-mono">// {tourney.game}</span>
          </div>
          <h3 className="text-xl sm:text-2xl font-chakra font-black uppercase tracking-wide text-white flex items-center gap-2">
            <Trophy className="w-6 h-6 text-amber-400 shrink-0" />
            <span>{tourney.title}</span>
          </h3>
        </div>

        {/* Tab Switcher */}
        <div className="flex items-center gap-2 bg-[#05070d] p-1 rounded-lg border border-[#141b2a]">
          <button
            onClick={() => setActiveTab("cs16_cup")}
            className={`px-3 py-1.5 rounded-md text-xs font-chakra font-black uppercase tracking-wider transition-all ${
              activeTab === "cs16_cup"
                ? "bg-[var(--tf-primary)] text-black shadow-md"
                : "text-zinc-400 hover:text-white"
            }`}
          >
            CS 1.6 Masters
          </button>
          <button
            onClick={() => setActiveTab("cs2_cup")}
            className={`px-3 py-1.5 rounded-md text-xs font-chakra font-black uppercase tracking-wider transition-all ${
              activeTab === "cs2_cup"
                ? "bg-[#00ff88] text-black shadow-md"
                : "text-zinc-400 hover:text-white"
            }`}
          >
            CS2 Premier
          </button>
        </div>
      </div>

      {/* Prize Pool & CTA Banner */}
      <div className="mb-6 p-4 rounded-lg bg-gradient-to-r from-amber-500/10 via-amber-500/5 to-transparent border border-amber-500/30 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="flex items-center gap-3 text-center sm:text-left">
          <div className="w-10 h-10 rounded-lg bg-amber-500/20 border border-amber-500/40 flex items-center justify-center text-amber-400 shrink-0">
            <Crown className="w-5 h-5" />
          </div>
          <div>
            <div className="text-[10px] font-mono uppercase text-amber-400/80 font-bold tracking-wider">
              FOND DE PREMII GARANTAT
            </div>
            <div className="text-sm sm:text-base font-chakra font-black uppercase text-amber-300">
              {tourney.prize}
            </div>
          </div>
        </div>

        <Link
          to="/turnee"
          className="px-5 py-2.5 rounded-lg bg-amber-400 hover:bg-amber-300 text-black font-chakra font-black text-xs uppercase tracking-wider flex items-center gap-2 transition-all shadow-lg hover:scale-105"
        >
          <span>⚔</span>
          <span>ÎNSCRIE ECHIPA</span>
          <ChevronRight className="w-4 h-4" />
        </Link>
      </div>

      {/* Bracket Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 relative">
        {/* Column 1: Quarter Finals */}
        <div className="space-y-3">
          <div className="text-xs font-chakra font-black uppercase tracking-widest text-zinc-400 flex items-center justify-between border-b border-[#141b2a] pb-2">
            <span>Sferturi de Finală</span>
            <span className="text-[10px] font-mono text-zinc-400">BO1 / MAP PICK</span>
          </div>

          <div className="space-y-2.5">
            {tourney.quarterFinals.map((m, idx) => (
              <div key={idx} className="bg-[#05070d] border border-[#141b2a] hover:border-zinc-700 rounded-lg p-2.5 transition-all">
                <div className={`flex items-center justify-between text-xs font-mono py-1 px-2 rounded ${m.winner === 1 ? 'bg-emerald-500/10 text-emerald-400 font-bold' : 'text-zinc-400'}`}>
                  <span className="truncate">{m.t1}</span>
                  <span className="font-chakra font-bold">{m.s1}</span>
                </div>
                <div className={`flex items-center justify-between text-xs font-mono py-1 px-2 rounded mt-1 ${m.winner === 2 ? 'bg-emerald-500/10 text-emerald-400 font-bold' : 'text-zinc-400'}`}>
                  <span className="truncate">{m.t2}</span>
                  <span className="font-chakra font-bold">{m.s2}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Column 2: Semi Finals */}
        <div className="space-y-3">
          <div className="text-xs font-chakra font-black uppercase tracking-widest text-cyan-400 flex items-center justify-between border-b border-[#141b2a] pb-2">
            <span>Semifinale</span>
            <span className="text-[10px] font-mono text-cyan-400/80">BO3 SERIES</span>
          </div>

          <div className="space-y-4 pt-2">
            {tourney.semiFinals.map((m, idx) => (
              <div key={idx} className={`bg-[#05070d] border rounded-lg p-3 transition-all ${m.live ? 'border-cyan-500/50 shadow-[0_0_15px_rgba(0,245,155,0.15)]' : 'border-[#141b2a]'}`}>
                {m.live && (
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-[9px] font-mono uppercase bg-cyan-500/20 text-cyan-400 px-2 py-0.5 rounded font-black flex items-center gap-1">
                      <span className="w-1.5 h-1.5 rounded-full bg-cyan-400 animate-pulse" />
                      LIVE MATCH
                    </span>
                    <span className="text-[9px] font-mono text-zinc-500">MAP 2/3</span>
                  </div>
                )}
                <div className={`flex items-center justify-between text-xs font-mono py-1 px-2 rounded ${m.winner === 1 ? 'bg-emerald-500/10 text-emerald-400 font-bold' : 'text-zinc-300'}`}>
                  <span className="truncate font-semibold">{m.t1}</span>
                  <span className="font-chakra font-black text-sm">{m.s1}</span>
                </div>
                <div className={`flex items-center justify-between text-xs font-mono py-1 px-2 rounded mt-1.5 ${m.winner === 2 ? 'bg-emerald-500/10 text-emerald-400 font-bold' : 'text-zinc-300'}`}>
                  <span className="truncate font-semibold">{m.t2}</span>
                  <span className="font-chakra font-black text-sm">{m.s2}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Column 3: Grand Final */}
        <div className="space-y-3">
          <div className="text-xs font-chakra font-black uppercase tracking-widest text-amber-400 flex items-center justify-between border-b border-[#141b2a] pb-2">
            <span>Marea Finală</span>
            <span className="text-[10px] font-mono text-amber-400">BO5 CHAMPIONSHIP</span>
          </div>

          <div className="bg-gradient-to-b from-amber-500/10 to-[#05070d] border border-amber-500/40 rounded-xl p-4 text-center space-y-3 relative shadow-lg">
            <div className="w-12 h-12 rounded-full bg-amber-500/20 border border-amber-500/40 flex items-center justify-center text-amber-400 mx-auto shadow-[0_0_20px_rgba(245,158,11,0.2)]">
              <Trophy className="w-6 h-6" />
            </div>

            <div>
              <div className="text-sm font-chakra font-black uppercase text-white tracking-wider">
                {tourney.grandFinal.t1}
              </div>
              <div className="text-[11px] font-mono text-amber-400 font-bold my-1">
                VS
              </div>
              <div className="text-sm font-chakra font-black uppercase text-zinc-300 tracking-wider">
                {tourney.grandFinal.t2}
              </div>
            </div>

            <div className="pt-2 border-t border-white/10 text-[11px] font-mono text-zinc-400">
              <div>📅 {tourney.grandFinal.date}</div>
              <div className="text-[10px] text-zinc-500 mt-0.5">🗺 {tourney.grandFinal.map}</div>
            </div>

            <Link
              to="/turnee"
              className="block w-full py-2 bg-amber-500 hover:bg-amber-400 text-black font-chakra font-black text-xs uppercase tracking-wider rounded transition-all shadow-md mt-2"
            >
              VEZI DETALII & STREAM
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
